export enum CustomerGroup {
    INDUSTRY_PAID = 'IndustryPaid',
    ACADEMIA_STUDENT = 'AcademiaStudent',
    INTERNAL_ADMIN = 'InternalAdmin',
    ACADEMIA_PAID = 'AcademiaPaid',
    ACADEMIA_NON_STUDENT = 'AcademiaNonStudent',
    ACADEMIA_BUNDLE = 'AcademiaBundle',
    INDUSTRY_BUNDLE = 'IndustryBundle',
    INDUSTRY_TRIAL = 'IndustryTrial',
    INTERNAL_SALES = 'InternalSales',
}
